export default class AlertType {
    static get SUCESSO() {
        return {
            id: 1,
            textColor: "white",
            type: "success",
            title: "Sucesso!"            
        };
    }

    static get ALERTA() {
        return {
            id: 2,
            textColor: "white",
            type: "warning",
            title: "Atenção!"            
        };
    }

    static get INFO() {
        return {
            id: 3,
            textColor: "white",
            type: "info",
            title: "Informativo!"            
        };
    }

    static get ERRO() {
        return {
            id: 4,
            textColor: "white",
            type: "error",
            title: "Erro!"            
        };
    }
}